/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ComponentTypeEnum = 'IRR' | 'CDVX' | 'LAMBDA' | 'CLOUDRUN_CONTAINER';

export const ComponentTypeEnum = {

    IRR: 'IRR' as ComponentTypeEnum,

    CDVX: 'CDVX' as ComponentTypeEnum,

    LAMBDA: 'LAMBDA' as ComponentTypeEnum,

    CLOUDRUN_CONTAINER: 'CLOUDRUN_CONTAINER' as ComponentTypeEnum
};

